const secondaryNav = document.querySelector(".m-sibling-nav--mobile-visible");

export function showSecondaryNav(overlayRef) {
  if (!secondaryNav) return;

  const timeout = getOverlayTransitionDuration(overlayRef);

  setTimeout(() => {
    secondaryNav.style.zIndex = null;
  }, timeout);
}

export function hideSecondaryNav() {
  if (!secondaryNav) return;

  secondaryNav.style.zIndex = 0;
}

function getOverlayTransitionDuration(overlayRef) {
  if (!overlayRef) return 0;

  const computedStyles = window.getComputedStyle(overlayRef);
  const duration = computedStyles.getPropertyValue("transition-duration");

  if (!duration) return 0;
  if (typeof duration === "number") return duration;
  if (duration.includes("ms")) return parseInt(duration, 10);
  return parseFloat(duration) * 1000; // assume duration is in seconds
}
